// Tee times travel as Postgres time-of-day strings ('14:10:00'). This is the one place that
// turns them into what a golfer reads ('2:10 PM'). Pure on purpose: the web board imports it,
// and anything under sync/ drags the native Supabase client into a browser build.

/**
 * A group's `tee_time` ('HH:MM:SS', Postgres `time` off the wire) as a local 12-hour clock
 * reading with no seconds — "8:10 AM", the way a cart sign would print it, never the raw
 * 24-hour string a database column holds. Returns null on anything that does not parse
 * rather than showing a malformed time; the caller falls back to the shotgun "starts on hole
 * N" line in that case.
 */
export function fmtTeeTime(hms: string | null | undefined): string | null {
  if (!hms) return null;
  const m = /^(\d{1,2}):(\d{2})(?::\d{2})?$/.exec(hms.trim());
  if (!m) return null;
  const hour24 = parseInt(m[1], 10);
  const minute = m[2];
  if (!Number.isInteger(hour24) || hour24 < 0 || hour24 > 23) return null;
  const suffix = hour24 >= 12 ? 'PM' : 'AM';
  const hour12 = hour24 % 12 === 0 ? 12 : hour24 % 12;
  return `${hour12}:${minute} ${suffix}`;
}
